export * from './alert.directive';



// WEBPACK FOOTER //
// ./src/app/directives/alert/index.ts